import { render, staticRenderFns } from "./HippaAgreement.vue?vue&type=template&id=24181cb2&scoped=true"
import script from "./HippaAgreement.vue?vue&type=script&lang=js"
export * from "./HippaAgreement.vue?vue&type=script&lang=js"
import style0 from "./HippaAgreement.vue?vue&type=style&index=0&id=24181cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24181cb2",
  null
  
)

export default component.exports